import React from "react";
import "../../styles/Shared/Shared.css";
import "../../styles/Expense_Tracker/Styles_Expense_Tracker.css"
import View_Expenses from "./View_Expenses";
import Expenses_History from "./Expenses_History";
import Add_Transaction_Page from "./Add_Transaction_Page";

const Expense_Tracker = (props) => {
    return (
        <div className="expense_tracker_container">
            <div className="expense_tracker_main">
                <h1 className="expense_tracker_title">Expense Tracker</h1>
                <View_Expenses/>
                <Expenses_History/>
                <Add_Transaction_Page/>
            </div>
        </div>
    );
};

export default Expense_Tracker;